module.exports = __webpack_public_path__ + "static/media/15ditton_edited.d128a4a3.jpg";